import * as React from "react";

import "./bulk-mail-permit.scss";

import {cs}             from "@Common/react/chain-services";
import {SliderCheckbox} from "@Common/ui-components/slider-checkbox/slider-checkbox";

export const BulkMailPermit = ({state, content}) => cs(
    ({}) => (
        <div className="bulk-mail-permit bulk-mail-permit-5lt" xd-qa-type="card" xd-qa-name="Use Bulk Mail Permit">
            <div className="header">
                <div className="text">
                    Use Bulk Mail Permit?
                </div>

                {SliderCheckbox({value: state.value, onChange: state.onChange, xdQaName: "Use Bulk Mail Permit Slider"})}
            </div>

            {content}

        </div>
    ),
);
